import github from "../assets/icons/icons8-github.gif";
import twitter from "../assets/icons/icons8-twitter.gif";
import email from "../assets/icons/icons8-gmail-logo.gif";
import linkedin from "../assets/icons/icons8-linkedin-circled.gif";

const social = {
  github: github,
  twitter: twitter,
  linkedin: linkedin,
  email: email,
  social_links: {
    gith: "https://github.com/oluyaratosin123",
    twit: "https://twitter.com/TOluyara",
    link: "https://www.linkedin.com/in/edward-oluyara-708b88215/",
    em: "oluyaratosin123@gmail.com",
  },
};

export { social };
